<template>
	<AppTooltip v-if="isShowingEverything || alwaysShowProjectChip" position="bottom" text="Open space">
		<router-link class="router-link" :to="{ name: 'Features', params: { pID: redirectTo } }">
			<div class="project-type-chip flex-centerize px-1 mr-1">
				<SIcon class="icon" :name="projectIconIndicatorName" width="10" />
				{{ projectTitle }}
			</div>
		</router-link>
	</AppTooltip>
</template>

<script>
import { projectsList } from '@/store/modules/projects/getters';
import { selectedProjectId } from '@/store/modules/selectedProject/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import ProjectService from '@/utils/projects-service';
import { ALL_PROJECTS_VIRTUAL_ID, PROJECTS_SHARED_WITH_ME_VIRTUAL_ID, PROJECTS_SHARED_WITH_ME_VIRTUAL_TITLE } from '@/utils/projects.const';
export default {
	name: 'ProjectChip',
	props: {
		alwaysShowProjectChip: { type: Boolean },
		projectId: { type: [Number, String], default: () => PROJECTS_SHARED_WITH_ME_VIRTUAL_ID },
	},
	computed: {
		...mapGettersShorthand({ selectedProjectId, projectsList }),
		project() {
			return this.allProjects.find((proj) => proj.id === this.projectId);
		},
		redirectTo() {
			return this.project ? this.projectId : PROJECTS_SHARED_WITH_ME_VIRTUAL_ID;
		},
		projectTitle() {
			return this.project ? this.project?.title || '' : PROJECTS_SHARED_WITH_ME_VIRTUAL_TITLE;
		},
		projectIconIndicatorName() {
			if (!this.project) {
				return 'shared-with-me';
			}
			return `${this.isPersonalProject ? 'personal' : 'collaborative'}-space`;
		},
		isPersonalProject() {
			return ProjectService.isPersonalProject(this.project);
		},
		allProjects() {
			const virtualProjects = [
				{
					title: PROJECTS_SHARED_WITH_ME_VIRTUAL_TITLE,
					description: 'Features shared with me',
					id: PROJECTS_SHARED_WITH_ME_VIRTUAL_ID,
				},
			];
			const realProjects = this.projectsList;
			return [...virtualProjects, ...realProjects];
		},
		projectIdentifier() {
			const identifier = this.selectedProjectId;
			return isNaN(identifier) ? identifier.toLowerCase() : identifier;
		},
		isShowingEverything() {
			return this.projectIdentifier == ALL_PROJECTS_VIRTUAL_ID;
		},
	},
};
</script>

<style scoped lang="scss">
.project-type-chip {
	height: 16px;
	font-size: 12px;
	color: #9e9e9e;
	border-radius: 7px;
	background: #f5f5f5;
	border: 1px solid transparent;
	max-width: 120px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	&:hover {
		border-color: var(--border-color);
	}
}
.router-link {
	font-weight: normal;
	text-decoration: none;
}
.icon {
	opacity: 0.7;
	margin-right: 3px;
}
</style>
